import { createContext } from '@hover/blueprint';
import type { PropsWithChildren } from 'react';
import React, { useState } from 'react';

import { useQueryParam } from 'src/shared/hooks/useQueryParam';

export type EmbedContext = boolean;

const [Provider, useContext] = createContext<EmbedContext | undefined>({
  strict: false,
});

export interface EmbedProviderProps extends PropsWithChildren<{}> {}

export const EmbedProvider = (props: EmbedProviderProps) => {
  const isEmbedQueryParam = useQueryParam('isEmbed') === 'true';
  const [isEmbed, setIsEmbed] = useState(isEmbedQueryParam);

  if (isEmbedQueryParam && !isEmbed) setIsEmbed(true);

  return <Provider value={isEmbed} {...props} />;
};

/**
 * Whether the application is in an embedded context (in an iframe)
 *
 * It returns true if query string isEmbed equals true. Once the value becomes
 * true, it remains true regardless if the isEmbed query param is removed. A
 * page refresh will reset the value based on the presence of the isEmbed query
 * string.
 */
export const useIsEmbed = () => useContext() ?? false;
